export default "__VITE_ASSET__DI2s_VE___"